/**
 * TenantPort design tokens — "Theme D: Brand".
 *
 * Mirror of the canonical token file at
 * `tenantport-admin/src/shared/theme/tokens.js` (that file is canonical —
 * when a value changes there, change it here too). Derived from the brand
 * logo files: teal #387C88 + deep teal #2C626B (the wordmark ink), with
 * teal-tinted neutrals and geometric-rounded type (Poppins display /
 * DM Sans UI) echoing the All Round Gothic wordmark.
 *
 * Pure data — no MUI imports, no functions.
 */

const tokens = {
  colors: {
    // Brand
    primary: "#387C88",
    primaryDeep: "#2C626B", // wordmark ink — hover, active, emphasis
    primaryDark: "#1E444B",
    primarySoft: "#E3EFF0", // active pills, soft chips, selected rows
    primaryTint: "#C5DDE0",

    // Ink (teal-tinted text scale)
    ink: "#182F33",
    inkSecondary: "#466064",
    inkMuted: "#5E7579",
    inkFaint: "#9FB0B1",

    // Surfaces
    pageBg: "#F5F8F8",
    surface: "#FFFFFF",
    tableHeadBg: "#EFF5F5",
    hover: "#F1F6F6",

    // Borders
    border: "#DCE4E5",
    borderStrong: "#CFDBDD",

    // Status
    success: { bg: "#E3F4E6", fg: "#1F7A33", main: "#2E8B44" },
    warning: { bg: "#FCF1DC", fg: "#96660A", main: "#B37B0D" },
    error: { bg: "#FBE7EA", fg: "#A4233F", main: "#B3273E", border: "#EBB4BF" },
    info: { bg: "#E3EFF0", fg: "#2C626B", main: "#387C88" },
    neutral: { bg: "#EDF1F1", fg: "#5A6F6F" },

    focusRing: "rgba(56, 124, 136, 0.30)",
    overlay: "rgba(24, 47, 51, 0.34)",
  },

  fonts: {
    body: "'DM Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
    display: "'Poppins', 'DM Sans', -apple-system, sans-serif",
    mono: "ui-monospace, SFMono-Regular, Menlo, Consolas, monospace",
  },

  radius: {
    sm: 7, // inputs, buttons, small controls
    md: 10, // cards, panels, tables
    lg: 14, // dialogs, large surfaces
    pill: 99,
  },

  shadows: {
    card: "0px 1px 2px rgba(24, 47, 51, 0.05), 0px 3px 10px rgba(24, 47, 51, 0.05)",
    overlay: "0px 10px 34px rgba(24, 47, 51, 0.20)",
  },

  layout: {
    sidebarWidth: 240,
    contentNarrow: 640,
    contentDefault: 960,
    contentWide: 1200,
    mobileTabBarHeight: 72,
  },
} as const;

export default tokens;
